var e;!function(e){e.Input="input",e.Select="select",e.Enter="enter",e.AccessorSelect="accessorSelect"}(e||(e={}));export{e as Events};
//# sourceMappingURL=types.js.map
